import { Avatar } from "@mui/material";
import holdenPic from "./IMG_8564.png";
import accessibilityDocsPic from "./a11yDocs.png";
import elexResultsPagePic from "./elexResultsPage.png";
import coreWebVitalsPic from "./cwv.png";
import stanfordDailyPic from "./stanfordDaily.png";
import iWillVotePic from "./iwillvote.png";
import agendaWatchPic from "./agendaWatch.png";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";

import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import EmailIcon from "@mui/icons-material/Email";

import "./App.css";

const CARD_MIN_HEIGHT = 200;
const CARD_MAX_WIDTH = 375;

function App() {
  return (
    <div className="App-wrapper">
      <div
        style={{
          width: "100%",
          justifyContent: "center",
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        <Avatar
          alt="Headshot of Holden Foreman, with a blue sky and brick apartment buildings behind him, wearing a dark blue quarter zip with a white t-shirt underneath it"
          src={holdenPic}
          sx={{ marginRight: 5, width: "10vw", height: "10vw" }}
        />
        <a href="https://www.linkedin.com/in/holdenforeman">
          <span className="sr-only">Holden's LinkedIn</span>
          <Avatar
            sx={{
              marginRight: 5,
              width: "10vw",
              height: "10vw",
              bgcolor: "#0047AB",
            }}
          >
            <LinkedInIcon sx={{ width: "8vw", height: "8vw" }} />
          </Avatar>
        </a>
        {/* <a href="https://twitter.com/hsforeman">
          <span className="sr-only">Holden's Twitter</span>
          <Avatar
            sx={{
              marginRight: 5,
              width: "10vw",
              height: "10vw",
              bgcolor: "#0047AB",
            }}
          >
            <TwitterIcon sx={{ width: "8vw", height: "8vw" }} />
          </Avatar>
        </a> */}
        <a href="https://github.com/hs4man21">
          <span className="sr-only">Holden's GitHub</span>
          <Avatar
            sx={{
              marginRight: 5,
              width: "10vw",
              height: "10vw",
              bgcolor: "#0047AB",
            }}
          >
            <GitHubIcon sx={{ width: "8vw", height: "8vw" }} />
          </Avatar>
        </a>
        <a href="mailto:hsforeman98@gmail.com">
          <span className="sr-only">Send an email to Holden</span>
          <Avatar sx={{ width: "10vw", height: "10vw", bgcolor: "#0047AB" }}>
            <EmailIcon sx={{ width: "8vw", height: "8vw" }} />
          </Avatar>
        </a>
      </div>
      <p>
        Holden Foreman (he/him) is a full stack software engineer
        <br aria-hidden />
        with specialized knowledge in acessibility, web performance and design systems.
      </p>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-around",
          alignContent: "space-around",
          flexWrap: "wrap",
        }}
      >
        <a href="https://iwillvote.com">
          <Card sx={{ maxWidth: CARD_MAX_WIDTH, marginBottom: 5 }}>
            <CardMedia
              sx={{ height: 169, width: CARD_MAX_WIDTH }}
              image={iWillVotePic}
              title="Screenshot of Washington Post Design System accessibility documentation website"
            />
            <CardContent sx={{ minHeight: CARD_MIN_HEIGHT }}>
              <Typography gutterBottom variant="h5" component="div">
                Voter education site iwillvote.com
              </Typography>
              <Typography variant="body2" color="text.secondary">
                At the Democratic National Committee, I work on our flagship
                voter education site iwillvote.com. Some of my areas of focus
                have included internationalization, accessibility and working
                with PMs and designers to build new components for the 2024 election cycle.
                I have also contributed to internal tooling at the DNC.
              </Typography>
            </CardContent>
          </Card>
        </a>
        <a href="https://build.washingtonpost.com/resources/accessibility">
          <Card sx={{ maxWidth: CARD_MAX_WIDTH, marginBottom: 5 }}>
            <CardMedia
              sx={{ height: 169, width: CARD_MAX_WIDTH }}
              image={accessibilityDocsPic}
              title="Screenshot of Washington Post Design System accessibility documentation website"
            />
            <CardContent sx={{ minHeight: CARD_MIN_HEIGHT }}>
              <Typography gutterBottom variant="h5" component="div">
                Creating accessibility standards at The Washington Post
              </Typography>
              <Typography variant="body2" color="text.secondary">
                As The Washington Post's first-ever Accessibility Engineer, I
                worked across teams to document and implement best practices
                open-sourced in the Washington Post Design System
                (WPDS). I also led educational initiatives and created newsroom tools. I was <a href="https://www.niemanlab.org/2023/02/meet-the-first-ever-accessibility-engineer-at-the-washington-post/">interviewed by NiemanLab</a> about my work.
              </Typography>
            </CardContent>
          </Card>
        </a>
        <a href="https://www.washingtonpost.com/elections/midterms-2022/">
          <Card sx={{ maxWidth: CARD_MAX_WIDTH, marginBottom: 5 }}>
            <CardMedia
              sx={{ height: 169, width: CARD_MAX_WIDTH }}
              image={elexResultsPagePic}
              title="Screenshot of The Washington Post's 2022 midterms election results landing page"
            />
            <CardContent sx={{ minHeight: CARD_MIN_HEIGHT }}>
              <Typography gutterBottom variant="h5" component="div">
                Live election results components & pages
              </Typography>
              <Typography variant="body2" color="text.secondary">
                From 2021-22, I worked on engineering live elections results
                coverage at The Washington Post. I worked primarily in Next.js,
                Node.js, TypeScript and Python. Projects included building
                new components, updating internal admins to support them
                and reformatting data e.g. exporting vote counts from Dynamo to xml.
              </Typography>
            </CardContent>
          </Card>
        </a>
        <a href="https://washpost.engineering/how-we-enhanced-our-sites-ux-and-boosted-core-web-vitals-scores-960fb49e7eab?source=search_post---------0----------------------------">
          <Card sx={{ maxWidth: CARD_MAX_WIDTH, marginBottom: 5 }}>
            <CardMedia
              sx={{ height: 169, width: CARD_MAX_WIDTH }}
              image={coreWebVitalsPic}
              title="Screenshot showing how WaPo's Core Web Vitals scores where roughly the same throughout July 2021 until the end of the month, at which point the percent of URLs in the red or yellow (aka bad) dropped steeply while the percent of URLs in the green (aka good) rose steeply"
            />
            <CardContent sx={{ minHeight: CARD_MIN_HEIGHT }}>
              <Typography gutterBottom variant="h5" component="div">
                Web performance & SEO experience
              </Typography>
              <Typography variant="body2" color="text.secondary">
                As an intern at The Washington Post, one of my projects was improving The Post's Core Web Vitals
                scores for SEO/Google PageRank. I blogged about this and more on
                washpost.engineering. I also paired with another intern to build a
                Flask-React full-stack application from scratch for newsroom use.
              </Typography>
            </CardContent>
          </Card>
        </a>
        <a href="https://agendawatch.org/">
          <Card sx={{ maxWidth: CARD_MAX_WIDTH, marginBottom: 5 }}>
            <CardMedia
              sx={{ height: 169, width: CARD_MAX_WIDTH }}
              image={agendaWatchPic}
              title="Screenshot of the Agenda Watch homepage, which says 'Keep watch on local government.'"
            />
            <CardContent sx={{ minHeight: CARD_MIN_HEIGHT }}>
              <Typography gutterBottom variant="h5" component="div">
                Open source development & social media bots
              </Typography>
              <Typography variant="body2" color="text.secondary">
                I have contributed to multiple open-source projects. In the Stanford course CS 206, I co-developed the original Agenda Watch
                website and tool for local journalists to track local government meetings. An alt text bot that
                I set up was used thousands of times on the social media network Bluesky.
              </Typography>
            </CardContent>
          </Card>
        </a>
        <a href="https://stanforddaily.com/author/holden-foreman/page/2/">
          <Card sx={{ maxWidth: CARD_MAX_WIDTH, marginBottom: 5 }}>
            <CardMedia
              sx={{ height: 169, width: CARD_MAX_WIDTH }}
              image={stanfordDailyPic}
              title="Screenshot of Holden's profile page on the Stanford Daily website"
            />
            <CardContent sx={{ minHeight: CARD_MIN_HEIGHT }}>
              <Typography gutterBottom variant="h5" component="div">
                Journalism background & soft skills
              </Typography>
              <Typography variant="body2" color="text.secondary">
                In college, I was editor-in-chief and chief technology officer
                at The Stanford Daily. I trained other students to code on our custom WordPress site. I built tools like our email digest generator. Conveying technical
                concepts to folks with non-technical backgrounds is an important
                skill I picked up in the process.
              </Typography>
            </CardContent>
          </Card>
        </a>
      </div>
      <p style={{ fontSize: "0.875rem" }}>
        This website was built using{" "}
        <a href="https://create-react-app.dev/">create-react-app</a>,{" "}
        <a href="https://mui.com/">Material UI</a> and{" "}
        <a href="https://pages.github.com/">GitHub Pages</a>.
      </p>
    </div>
  );
}

export default App;
